export const LIGHTNING_LIST_PATH = "get_lightning_list";
//# sourceMappingURL=MeteomaticsApiConst.js.map